import { mockConsumerAbi } from '@/abi'
import { useReadContract } from 'wagmi'

export const useGetRandom = ({ requestId, consumerAddress }) => {
  const { data: lastRequest, isLoading } = useReadContract({
    address: consumerAddress,
    functionName: 'getRandom',
    abi: mockConsumerAbi,
    args: [requestId],
    enabled: !!requestId && !!consumerAddress,
  })

  return {
    data: lastRequest?.length || null,
    isLoading,
  }
}
